"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var CancelRounded_1 = __importDefault(require("@mui/icons-material/CancelRounded"));
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return ({
        imageContainer: (_a = {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                left: '0',
                height: 'calc(100vh - 86px)',
                width: '100vw',
                backgroundColor: 'rgba(0,0,0,0.7)',
                cursor: 'pointer',
                zIndex: 8
            },
            _a[theme.breakpoints.up('md')] = {
                top: 0,
                height: '100%',
            },
            _a),
        imageWrapper: {
            display: 'flex',
            width: 'auto',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.spacing(4),
        },
        image: (_b = {
                maxHeight: 'calc(75vh - 86px)',
                // maxWidth: '90vw',
                width: 'auto',
                borderRadius: theme.spacing(4)
            },
            _b[theme.breakpoints.up('md')] = {
                maxHeight: 'calc(85vh - 170px)',
            },
            _b),
        closeIcon: {
            alignSelf: 'flex-end',
            color: '#fff',
            right: '-40px',
            top: '-20px',
        },
        embedResponsive: (_c = {
                borderRadius: theme.spacing(4),
                position: 'relative',
                display: 'block',
                width: '90vw',
                padding: '56.25% 0 0 0',
                overflow: 'hidden'
            },
            _c[theme.breakpoints.up('md')] = {
                width: '60vw',
            },
            _c),
        embedResponsiveItem: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
        },
    });
});
var CrudeLightBox = function (props) {
    var _a = react_1.useState(props.isOpen), isOpen = _a[0], setIsOpen = _a[1];
    var classes = useStyles();
    var src = props.src;
    var alt = props.alt || '';
    var videoSrc = null;
    react_1.useEffect(function () {
        if (!isOpen) {
            props.onClose && props.onClose();
        }
    }, [isOpen]);
    react_1.useEffect(function () {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);
    var videoImage = src
        ? "<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=" + videoSrc + "><img src=" + src + " alt=''/><span>\u25B6</span></a>"
        : "<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}div{position:relative;height:100%;width:100%;background-color: #eeeeee}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=" + videoSrc + "><div><div/><span>\u25B6</span></a>";
    return (react_1.default.createElement(react_1.default.Fragment, null, isOpen &&
        react_1.default.createElement("div", { className: classes.imageContainer },
            react_1.default.createElement("div", { className: classes.imageWrapper },
                react_1.default.createElement(material_1.IconButton, { className: "" + classes.closeIcon, color: 'default', component: 'div', onClick: function () { return setIsOpen(false); }, size: 'large' },
                    react_1.default.createElement(CancelRounded_1.default, null)),
                videoSrc ? (react_1.default.createElement("div", { className: classes.embedResponsive },
                    react_1.default.createElement("iframe", { id: '', style: {}, className: classes.embedResponsiveItem, scrolling: 'no', frameBorder: '0', allow: 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share', srcDoc: videoImage, allowFullScreen: true, onClick: function (e) { return e.stopPropagation(); } }))) : (react_1.default.createElement("img", { src: src, alt: alt, className: classes.image }))))));
};
exports.default = CrudeLightBox;
